import { render, staticRenderFns } from "./VideoTextSwitch.vue?vue&type=template&id=29e0955e"
import script from "./VideoTextSwitch.vue?vue&type=script&lang=ts"
export * from "./VideoTextSwitch.vue?vue&type=script&lang=ts"
import style0 from "./VideoTextSwitch.vue?vue&type=style&index=0&id=29e0955e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports